var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('Hero'),_vm._v(" "),_c('HowItWorks'),_vm._v(" "),_c('Video'),_vm._v(" "),_c('Examples'),_vm._v(" "),_c('SpecificUses'),_vm._v(" "),_c('Signup',{attrs:{"data":{
      title: 'Join the all-in-one video and filmmakers platform today.',
      subtitle: 'Create your best work without the hassle of messy license restrictions.'
    }}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }